export enum EBookStatus {
  book,
  success,
  error,
  busy,
}
